export function hasMinLength(value, minLength) {
    return String(value ?? '').length >= minLength;
}

export function isEmail(value) {
    const email = String(value ?? '').trim();
    if (!email) return false;

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isPasswordConfirmationValid(password, confirmation) {
    return String(password ?? '') === String(confirmation ?? '');
}
